// export  DsfMessageNotice from './messageNotice';

export const DsfMessageNotice = dsf.defineAsyncComponent("DsfMessageNotice", () => {
  return dsf.requestAsyncComponents($components.platform.DsfVirtualList).then(() => {
    return import(/*webpackChunkName:"platform_pc_homepage"*/ "./messageNotice.vue");
  });
});
